<template>
	<div class="OverviewMap">
		<img class="OverviewMap-img" :src="imgUrl" draggable="false">
		<div class="OverviewMap-currentViewport"
			 :style="currentViewportStyle()"
		></div>
	</div>
</template>
<script type="text/javascript">
	import $ from 'jquery';
	import draggable from 'jquery-ui/ui/widgets/draggable';
	export default {
		components: {},
		data(){
			return {
				$element: null,
				$currentViewport: null
			};
		},
		props: [
			'view',
			'generateUrl',
			'onDragStop',
			'viewport'
		],
		created(){
			this.$nextTick(() => this.initUI());
		},
		computed: {
			imgUrl(){
				return this.generateUrl(this.view.page, { size: 150 });
			},
		},
		methods: {
			currentViewportStyle(){
				let width = this.viewport.width < 1 ? this.viewport.width : 1;
				let height = this.viewport.height < 1 ? this.viewport.height : 1;
				let left = (this.viewport.left > 1 ? 1 : this.viewport.left);
				let top = (this.viewport.top > 1 ? 1 : this.viewport.top);
				return {
					width: `${width*100}%`,
					height: `${height*100}%` ,
					top: `${top*100}%`,
					left: `${left*100}%`
				};
			},
			initUI(){
				this.$element = $(this.$el);
				this.$currentViewport = this.$element.find('.OverviewMap-currentViewport');
				this.$currentViewport.draggable({
					containment: this.$element,
					stop: this.handleDragStop
				});
			},
			handleDragStop(e){
				const [width, height] = [this.$element.width(), this.$element.height()];
				const [viewportWidth, viewportHeight] = [
				  	this.$currentViewport.outerWidth(),
					this.$currentViewport.outerHeight()
				];
				const { top, left } = this.$currentViewport.position();
				const percentSize = {
					top: (top + viewportHeight / 2) * 100 / height,
					left: (left + viewportWidth / 2) * 100 / width
				};
				console.log(percentSize);

				this.onDragStop(percentSize);
			}
		}
	};

</script>
<style lang="css">
	#metadata-container {
		display: none;
	}

	.OverviewMap {
		overflow:hidden;
		background: white;
		width: 100%;
		height: 100%;
		position: relative;
		-webkit-touch-callout: none; /* iOS Safari */
		-webkit-user-select: none; /* Safari */
		-khtml-user-select: none; /* Konqueror HTML */
		-moz-user-select: none; /* Firefox */
		-ms-user-select: none; /* Internet Explorer/Edge */
		user-select: none;
	}

	.OverviewMap .OverviewMap-img {

	}

	.OverviewMap .OverviewMap-currentViewport {
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		width: 100%;
		height: 100%;
		border: 2px solid #30D9B3;
		z-index: 10;
		cursor: move;
		-webkit-touch-callout: none; /* iOS Safari */
		-webkit-user-select: none; /* Safari */
		-khtml-user-select: none; /* Konqueror HTML */
		-moz-user-select: none; /* Firefox */
		-ms-user-select: none; /* Internet Explorer/Edge */
		user-select: none;
	}
</style>



// WEBPACK FOOTER //
// OverviewMap.vue?3ebcb594